import { PromotionsProp, PromotionsItem } from '../models/sectionPromotions'
import { WebdoorList, WebdoorItem } from '../models/webdoor'

interface BannersData {
    webdoor: any[]
    carrossel: any[]
}

let cachedData: BannersData | null = null;
let fetchPromise: Promise<BannersData> | null = null;

export const getBannersData = async (): Promise<BannersData> => {
    if (cachedData) {
        return cachedData;
    }

    if (fetchPromise) {
        return fetchPromise;
    }

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const bannersApi = `${baseUrl}/api/banners-promoshell/`;

    fetchPromise = fetch(bannersApi)
        .then(response => response.json())
        .then(data => {
            cachedData = data;
            fetchPromise = null;
            return data;
        })
        .catch(error => {
            fetchPromise = null;
            console.error("Erro ao buscar dados da API:", error);
            throw error;
        });

    return fetchPromise;
};

export const getPromotions = async (): Promise<PromotionsProp> => {
    try {
        const data = await getBannersData();
        const promotions: PromotionsItem[] = [];
        
        data.carrossel.forEach((item: any, key: number) => {
            promotions.push({
                id: key.toString(),
                title: item.title,
                images: item.image,
                actions: [
                    {
                        title: item.label || 'Saiba mais',
                        url: item.link
                    }
                ]
            })
        });

        return [
            {
                title: "Promoções",
                description: "Campanhas ativas e anteriores para você acompanhar, participar e aproveitar no momento certo.",
                promotions: promotions
            }
        ];
    } catch (error) {
        console.error("Erro ao buscar dados de promoções:", error);
        return [];
    }
};

export const getWebdoors = async (): Promise<WebdoorList> => {
    try {
        const data = await getBannersData();
        const returnData: WebdoorItem[] = [];
        
        data.webdoor.forEach((item: any, key: number) => {
            returnData.push({
                id: key.toString(),
                title: item.campaign_title,
                link: item.campaign_url,
                images: {
                    desktop: item.image_desktop,
                    tablet: item.image_768,
                    mobile: item.image_mobile
                }
            })
        });

        return returnData;
    } catch (error) {
        console.error("Erro ao buscar dados de webdoor:", error);
        return [];
    }
};

export interface ForYourVehicleProps {
    headline: {
        title: string
        text: string
    }
}
